module.exports = __webpack_public_path__ + "img/6.7922a186.png";